import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { SharedModule } from '../../shared/shared.module';
import { AmChartsModule } from "@amcharts/amcharts3-angular";

import { routing } from './dashboard.routing';

import { Dashboard } from '.';
import { DashboardGeneratorComponent } from './dashboard-generator';
import { DashboardViewerComponent } from './dashboard-viewer';
import { TableGeneratorComponent } from './table-generator';
import { CardGeneratorComponent } from './card-generator';
import { DragDropModule } from 'primeng/dragdrop';
import { SortablejsModule } from 'ngx-sortablejs';

import { TableModule } from 'primeng/table';
// Primeng Libraries
import { DropdownModule } from 'primeng/dropdown';
import { TabViewModule } from 'primeng/tabview';

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        SharedModule,
        routing,
        DragDropModule,
        SortablejsModule,
        AmChartsModule,
        DropdownModule,
        TableModule,
        TabViewModule

    ],
    declarations: [
        Dashboard,
        DashboardGeneratorComponent,
        TableGeneratorComponent,
        CardGeneratorComponent,
        DashboardViewerComponent
    ],
    providers: [
        // CardChartService,
    ]
})
export class DashboardModule { }
